<template>
  <div class="page">
    <div class="page-body">
      <fwb-alert class="bg-yellow-50 text-yellow-500">
        Selamat Datang <strong> {{ this.userFullName }}.</strong>
        <!-- <span class="text-sm ml-2">(Level: {{ this.userLevel }})</span> -->
      </fwb-alert>

      <!-- Filter untuk non-admin -->
      <div
        v-if="!isAdmin && !isLoading"
        class="grid grid-cols-12 md:gap-4 mb-3"
      >
        <div
          class="col-span-12 md:col-span-2 mt-4 relative"
        >
          <InputSelect
            :label="''"
            placeholder="Pilih Tahun"
            v-model="filter.year"
            :options="yearList"
            @change="refreshData()"
          />
        </div>
        <div
          v-if="singleModule !== 'pertanian'"
          class="col-span-12 md:col-span-2 mt-4 relative"
        >
          <InputSelect
            :label="''"
            :placeholder="
              singleModule === 'peternakan' ? 'Pilih Triwulan' : 'Pilih Bulan'
            "
            v-model="filter.month"
            :options="singleModule === 'peternakan' ? triwulanList : monthList"
            @change="refreshData()"
          />
        </div>
      </div>

      <!-- Loading State -->
      <div
        v-show="isLoading"
        class="mt-4 card relative"
      >
        <div
          role="status"
          class="w-full p-4 border border-gray-200 rounded-md shadow animate-pulse md:p-6 dark:border-gray-700"
        >
          <div class="flex justify-around mb-2">
            <div
              class="h-5 bg-gray-200 rounded-full dark:bg-gray-700 w-1/4 mb-2.5"
            ></div>
          </div>
          <div>
            <div
              class="h-4 w-full h-2 mb-5 bg-gray-200 rounded-full dark:bg-gray-700"
            ></div>
            <div
              class="h-4 w-3/5 h-2 mb-5 bg-gray-200 rounded-full dark:bg-gray-700"
            ></div>
            <div
              class="h-4 w-4/5 h-2 mb-5 bg-gray-200 rounded-full dark:bg-gray-700"
            ></div>
            <div
              class="h-4 w-3/4 h-2 mb-5 bg-gray-200 rounded-full dark:bg-gray-700"
            ></div>
            <div
              class="h-4 w-2/4 h-2 mb-5 bg-gray-200 rounded-full dark:bg-gray-700"
            ></div>
          </div>
        </div>
      </div>

      <!-- PERIKANAN DASHBOARD -->
      <div v-if="!isLoading && hasAccessTo('perikanan')" class="mt-4">
        <h2 class="section-title mb-3">
          Data Perikanan
        </h2>

        <!-- Stats Cards -->
        <div class="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  PRODUKSI IKAN MAS (TON)
                </dt>
                <dd
                  class="stat-value"
                >
                  {{ this.numberFormat(this.perikananData.total_produksi.mas) }}
                </dd>
              </dl>
              <Icon
                icon="game-icons:fish"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  PRODUKSI IKAN NILA (TON)
                </dt>
                <dd
                  class="stat-value"
                >
                  {{
                    this.numberFormat(this.perikananData.total_produksi.nila)
                  }}
                </dd>
              </dl>
              <Icon
                icon="ion:fish-outline"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  PRODUKSI IKAN MUJAIR (TON)
                </dt>
                <dd
                  class="stat-value"
                >
                  {{
                    this.numberFormat(this.perikananData.total_produksi.mujair)
                  }}
                </dd>
              </dl>
              <Icon
                icon="iconoir:fish"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  PRODUKSI IKAN LELE (TON)
                </dt>
                <dd
                  class="stat-value"
                >
                  {{
                    this.numberFormat(this.perikananData.total_produksi.lele)
                  }}
                </dd>
              </dl>
              <Icon
                icon="game-icons:circling-fish"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  PRODUKSI UDANG VANAME (TON)
                </dt>
                <dd
                  class="stat-value"
                >
                  {{
                    this.numberFormat(this.perikananData.total_produksi.vaname)
                  }}
                </dd>
              </dl>
              <Icon
                icon="mdi:shrimp"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  JUMLAH TOTAL PRODUKSI (TON)
                </dt>
                <dd
                  class="stat-value"
                >
                  {{
                    (
                      parseFloat(this.perikananData.total_produksi.mas) +
                      parseFloat(this.perikananData.total_produksi.nila) +
                      parseFloat(this.perikananData.total_produksi.mujair) +
                      parseFloat(this.perikananData.total_produksi.lele) +
                      parseFloat(this.perikananData.total_produksi.vaname)
                    ).toFixed(3)
                  }}
                </dd>
              </dl>
              <Icon
                icon="mdi:chart-line"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>
        </div>

        <!-- Chart -->
        <div class="grid grid-cols-1 gap-5 lg:grid-cols-3 mt-4">
          <div
            class="col-span-3 card"
          >
            <div ref="barProduksiPerikananKecamatan"></div>
          </div>
        </div>
      </div>

      <!-- PETERNAKAN DASHBOARD -->
      <div v-if="!isLoading && hasAccessTo('peternakan')" class="mt-4">
        <h2 class="section-title mb-3">
          Data Peternakan
        </h2>

        <!-- Stats Cards -->
        <div
          class="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
        >
          <div
            class="card"
          >
            <div class="px-4 py-5 sm:p-6">
              <div class="flex justify-between items-start gap-3">
                <dl class="flex-1 min-w-0">
                  <dt
                    class="text-sm leading-5 font-medium text-gray-500 dark:text-gray-400 mb-2"
                  >
                    Usaha Peternakan Ayam Lokal
                  </dt>
                  <dd
                    class="stat-value"
                  >
                    {{
                      this.numberFormat(
                        this.peternakanData.total_ternak.ayam_lokal
                      )
                    }}
                  </dd>
                </dl>
                <Icon
                  icon="emojione-monotone:chicken"
                  width="22"
                  height="22"
                  class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
                />
              </div>
            </div>
          </div>

          <div
            class="card"
          >
            <div class="px-4 py-5 sm:p-6">
              <div class="flex justify-between items-start gap-3">
                <dl class="flex-1 min-w-0">
                  <dt
                    class="text-sm leading-5 font-medium text-gray-500 dark:text-gray-400 mb-2"
                  >
                    Usaha Peternakan Ayam Ras Pedaging
                  </dt>
                  <dd
                    class="stat-value"
                  >
                    {{
                      this.numberFormat(
                        this.peternakanData.total_ternak.ayam_ras_pedaging
                      )
                    }}
                  </dd>
                </dl>
                <Icon
                  icon="cbi:chicken"
                  width="22"
                  height="22"
                  class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
                />
              </div>
            </div>
          </div>

          <div
            class="card"
          >
            <div class="px-4 py-5 sm:p-6">
              <div class="flex justify-between items-start gap-3">
                <dl class="flex-1 min-w-0">
                  <dt
                    class="text-sm leading-5 font-medium text-gray-500 dark:text-gray-400 mb-2"
                  >
                    Usaha Peternakan Ayam Ras Petelur
                  </dt>
                  <dd
                    class="stat-value"
                  >
                    {{
                      this.numberFormat(
                        this.peternakanData.total_ternak.ayam_ras_petelur
                      )
                    }}
                  </dd>
                </dl>
                <Icon
                  icon="healthicons:animal-chicken-outline"
                  width="22"
                  height="22"
                  class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
                />
              </div>
            </div>
          </div>

          <div
            class="card"
          >
            <div class="px-4 py-5 sm:p-6">
              <div class="flex justify-between items-start gap-3">
                <dl class="flex-1 min-w-0">
                  <dt
                    class="text-sm leading-5 font-medium text-gray-500 dark:text-gray-400 mb-2"
                  >
                    Usaha Peternakan Itik
                  </dt>
                  <dd
                    class="stat-value"
                  >
                    {{
                      this.numberFormat(this.peternakanData.total_ternak.itik)
                    }}
                  </dd>
                </dl>
                <Icon
                  icon="game-icons:duck"
                  width="22"
                  height="22"
                  class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
                />
              </div>
            </div>
          </div>

          <div
            class="card"
          >
            <div class="px-4 py-5 sm:p-6">
              <div class="flex justify-between items-start gap-3">
                <dl class="flex-1 min-w-0">
                  <dt
                    class="text-sm leading-5 font-medium text-gray-500 dark:text-gray-400 mb-2"
                  >
                    Usaha Peternakan Kambing
                  </dt>
                  <dd
                    class="stat-value"
                  >
                    {{
                      this.numberFormat(
                        this.peternakanData.total_ternak.kambing
                      )
                    }}
                  </dd>
                </dl>
                <Icon
                  icon="game-icons:goat"
                  width="22"
                  height="22"
                  class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
                />
              </div>
            </div>
          </div>

          <div
            class="card"
          >
            <div class="px-4 py-5 sm:p-6">
              <div class="flex justify-between items-start gap-3">
                <dl class="flex-1 min-w-0">
                  <dt
                    class="text-sm leading-5 font-medium text-gray-500 dark:text-gray-400 mb-2"
                  >
                    Usaha Peternakan Domba
                  </dt>
                  <dd
                    class="stat-value"
                  >
                    {{
                      this.numberFormat(this.peternakanData.total_ternak.domba)
                    }}
                  </dd>
                </dl>
                <Icon
                  icon="game-icons:sheep"
                  width="22"
                  height="22"
                  class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
                />
              </div>
            </div>
          </div>

          <div
            class="card"
          >
            <div class="px-4 py-5 sm:p-6">
              <div class="flex justify-between items-start gap-3">
                <dl class="flex-1 min-w-0">
                  <dt
                    class="text-sm leading-5 font-medium text-gray-500 dark:text-gray-400 mb-2"
                  >
                    Usaha Peternakan Sapi Potong
                  </dt>
                  <dd
                    class="stat-value"
                  >
                    {{
                      this.numberFormat(
                        this.peternakanData.total_ternak.sapi_potong
                      )
                    }}
                  </dd>
                </dl>
                <Icon
                  icon="game-icons:cow"
                  width="22"
                  height="22"
                  class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Chart -->
        <div class="grid grid-cols-1 gap-5 lg:grid-cols-3 mt-4">
          <div
            class="col-span-3 card"
          >
            <div ref="barProduksiPeternakanKecamatan"></div>
          </div>
        </div>
      </div>

      <!-- PERTANIAN DASHBOARD -->
      <div v-if="!isLoading && hasAccessTo('pertanian')" class="mt-4">
        <h2 class="section-title mb-3">
          Data Pertanian
        </h2>

        <!-- Stats Cards -->
        <div class="grid grid-cols-1 gap-5 lg:grid-cols-4">
          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Jumlah Baris
                </dt>
                <dd
                  class="stat-value"
                >
                  {{ this.numberFormat(this.pertanianData.total_data.j_baris) }}
                </dd>
              </dl>
              <Icon
                icon="mdi:table-large"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Jumlah NIK
                </dt>
                <dd
                  class="stat-value"
                >
                  {{ this.numberFormat(this.pertanianData.total_data.j_nik) }}
                </dd>
              </dl>
              <Icon
                icon="mdi:account-card"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Jumlah Rencana Tanam
                </dt>
                <dd
                  class="stat-value"
                >
                  {{
                    this.numberFormat(
                      this.pertanianData.total_data.j_rencana_tanam
                    )
                  }}
                </dd>
              </dl>
              <Icon
                icon="mdi:sprout"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Jumlah Urea
                </dt>
                <dd
                  class="stat-value"
                >
                  {{ this.numberFormat(this.pertanianData.total_data.j_urea) }}
                </dd>
              </dl>
              <Icon
                icon="mdi:sack"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Jumlah NPK
                </dt>
                <dd
                  class="stat-value"
                >
                  {{ this.numberFormat(this.pertanianData.total_data.j_npk) }}
                </dd>
              </dl>
              <Icon
                icon="mdi:molecule"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Jumlah NPK Formula
                </dt>
                <dd
                  class="stat-value"
                >
                  {{
                    this.numberFormat(
                      this.pertanianData.total_data.j_npk_formula
                    )
                  }}
                </dd>
              </dl>
              <Icon
                icon="mdi:flask"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Jumlah Organic
                </dt>
                <dd
                  class="stat-value"
                >
                  {{
                    this.numberFormat(this.pertanianData.total_data.j_organic)
                  }}
                </dd>
              </dl>
              <Icon
                icon="mdi:leaf"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>
        </div>

        <!-- Chart -->
        <div class="grid grid-cols-1 gap-5 lg:grid-cols-3 mt-4">
          <div
            class="col-span-3 card"
          >
            <div ref="barProduksiPertanianKecamatan"></div>
          </div>
        </div>
      </div>

      <!-- KESEHATAN DASHBOARD (Kehamilan, Persalinan, Stunting) -->
      <div v-if="!isLoading && hasAccessTo('kesehatan')" class="mt-4">
        <h2 class="section-title mb-3">
          Data Kesehatan
        </h2>

        <!-- Kehamilan Stats -->
        <h3 class="text-lg font-semibold dark:text-white mb-3 mt-6">
          Data Ibu Hamil
        </h3>
        <div class="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Jumlah Ibu Hamil
                </dt>
                <dd
                  class="stat-value"
                >
                  {{ this.numberFormat(this.kehamilanData.total_data) }}
                </dd>
              </dl>
              <Icon
                icon="mdi:account-group"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Rata-Rata Umur
                </dt>
                <dd
                  class="stat-value"
                >
                  {{ this.numberFormat(this.kehamilanData.rata_rata_umur) }}
                </dd>
              </dl>
              <Icon
                icon="mdi:chart-bar"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Risiko Umur Muda
                </dt>
                <dd
                  class="stat-value"
                >
                  {{ this.numberFormat(this.kehamilanData.risiko_umur_muda) }}
                </dd>
              </dl>
              <Icon
                icon="mdi:alert-circle-outline"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>
        </div>

        <!-- Kehamilan Chart -->
        <div class="grid grid-cols-1 gap-5 lg:grid-cols-2 mt-4">
          <div
            class="col-span-2 card"
          >
            <div ref="barDistribusiUmurKehamilan"></div>
          </div>
        </div>

        <!-- Persalinan Stats -->
        <h3 class="text-lg font-semibold dark:text-white mb-3 mt-6">
          Data Persalinan
        </h3>
        <div class="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Jumlah Persalinan
                </dt>
                <dd
                  class="stat-value"
                >
                  {{ this.numberFormat(this.persalinanData.total_persalinan) }}
                </dd>
              </dl>
              <Icon
                icon="mdi:account-group"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Bayi Hidup
                </dt>
                <dd
                  class="stat-value"
                >
                  {{
                    this.numberFormat(
                      this.persalinanData.total_persalinan -
                        this.persalinanData.bayi_mati
                    )
                  }}
                </dd>
              </dl>
              <Icon
                icon="mdi:baby-carriage"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>

          <div
            class="col-span-3 md:col-span-1 card"
          >
            <div class="stat-body">
              <dl>
                <dt
                  class="stat-label"
                >
                  Bayi Mati
                </dt>
                <dd
                  class="stat-value"
                >
                  {{ this.numberFormat(this.persalinanData.bayi_mati) }}
                </dd>
              </dl>
              <Icon
                icon="mdi:alert-octagon-outline"
                width="22"
                height="22"
                class="stat-icon text-blue-600 bg-blue-50 dark:bg-blue-500/10 dark:text-blue-300"
              />
            </div>
          </div>
        </div>

        <!-- Persalinan Chart -->
        <div class="grid grid-cols-1 gap-5 lg:grid-cols-2 mt-4">
          <div
            class="col-span-2 card"
          >
            <div ref="barDistribusiUmurPersalinan"></div>
          </div>
        </div>

        <!-- Stunting Stats & Map -->
        <h3 class="text-lg font-semibold dark:text-white mb-3 mt-6">
          Data Stunting
        </h3>
        <div class="grid md:grid-cols-12 md:gap-4">
          <div
            class="col-span-12 md:col-span-4 mt-4 card relative overflow-x-auto"
            ref="barKecamatan"
            id="barKecamatan"
          ></div>
        </div>
      </div>

      <!-- Pesan untuk admin tanpa modul spesifik -->
      <div
        v-if="!isLoading && isAdmin"
        class="mt-4 bg-blue-50 dark:bg-blue-900 border border-blue-200 dark:border-blue-800 rounded-lg p-4"
      >
        <p class="text-blue-800 dark:text-blue-200 text-sm">
          Anda login sebagai <strong>Admin</strong>. Silakan gunakan menu
          navigasi untuk mengakses data masing-masing modul.
        </p>
      </div>
    </div>
  </div>
</template>
<script src="./dashboard-page.js"></script>